// extracted by mini-css-extract-plugin
module.exports = {"root":"WebshopBreadcrumb_root__dtr_s","breadcrumbMenuIcon":"WebshopBreadcrumb_breadcrumbMenuIcon__29bba"};